import { AiOutlineLoading3Quarters } from "react-icons/ai";

export default PipelineV2RunsLoading;

function PipelineV2RunsLoading() {
  return (
    <div className="flex h-[40dvh] w-full items-center justify-center mx-auto border rounded-lg">
      <div className="flex flex-col items-center">
        <AiOutlineLoading3Quarters className="animate-spin" />
      </div>
    </div>
  );
}
